import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BiometricsState } from './biometrics.state';

export const getBiometricsFeatureState = createFeatureSelector('biometrics');

export const selectBiometricsStep = createSelector(
  getBiometricsFeatureState,
  (state: BiometricsState) => state.step
);

export const selectBiometricsIsLoading = createSelector(
  getBiometricsFeatureState,
  (state: BiometricsState) => state.isLoading
);

export const selectKeynuaWidgetResponse = createSelector(
  getBiometricsFeatureState,
  (state: BiometricsState) => state.keynuaWidgetResponse
);

export const selectIsBiometricsFlag = createSelector(
  getBiometricsFeatureState,
  (state: BiometricsState) => state.isBiometrics
);
